import constants from '../shared/constants';

document.addEventListener('DOMContentLoaded', (): void => {
    const menuElement = document.getElementById(constants.targets.menu.main);
    const navbarBurger = document.getElementById(constants.targets.menu.burger);

    if (navbarBurger && menuElement) {
        const drillLinks = Array.from(menuElement.querySelectorAll<HTMLElement>(constants.targets.menu.drilldownLink));
        const backLinks = Array.from(menuElement.querySelectorAll<HTMLElement>(constants.targets.menu.backLink));

        const burgerLabel = navbarBurger.querySelector<HTMLElement>(constants.targets.menu.burgerLabel);
        if (!burgerLabel) return;

        navbarBurger.addEventListener('click', (): void => {
            navbarBurger.classList.toggle(constants.classes.active);
            menuElement.classList.toggle(constants.classes.active);
            document.documentElement.classList.toggle(constants.classes.menuOpen);

            if (navbarBurger.classList.contains(constants.classes.active)) {
                burgerLabel.innerHTML = navbarBurger.dataset.closeText ?? '';
            } else {
                burgerLabel.innerHTML = navbarBurger.dataset.menuText ?? '';
            }
        });

        document.addEventListener('click', (event: MouseEvent): void => {
            const target = event.target as Node;
            const isClickInside = menuElement.contains(target) || navbarBurger.contains(target);

            if (!isClickInside) {
                navbarBurger.classList.remove(constants.classes.active);
                menuElement.classList.remove(constants.classes.active);
                burgerLabel.innerHTML = navbarBurger.dataset.menuText ?? '';
                document.documentElement.classList.remove(constants.classes.menuOpen);
            }
        });

        drillLinks.forEach((drillLink) => {
            drillLink.addEventListener('click', (): void => {
                const targetMenu = drillLink.nextElementSibling as HTMLElement | null;
                targetMenu?.classList.add(constants.classes.active);
            }, false);
        });

        backLinks.forEach((backLink) => {
            backLink.addEventListener('click', (event: MouseEvent): void => {
                const targetMenu = (event.target as HTMLElement).closest<HTMLElement>(constants.targets.menu.child);
                targetMenu?.classList.remove(constants.classes.active);
            }, false);
        });
    }
});
